export default __webpack_public_path__ + "static/media/556.1376de0e.png";